import { Box } from '@mui/material'
import React from 'react'
import { useEffect, useState } from 'react'

const BASE_HEIGHT = 1080

export const ScaledLayout = ({ children }: { children: React.ReactNode }) => {
	const [scale, setScale] = useState(1)

	useEffect(() => {
		const onResize = () => setScale(window.innerHeight / BASE_HEIGHT)
		onResize()
		window.addEventListener('resize', onResize)
		return () => window.removeEventListener('resize', onResize)
	}, [])

	return (
		<Box
			sx={{
				width: '100vw',
				height: '100vh',
				overflow: 'hidden'
			}}
		>
			<Box
				sx={{
					transform: `scale(${scale})`,
					transformOrigin: 'top left',
					width: `calc(100% / ${scale})`,
					height: `calc(100% / ${scale})`
				}}
			>
				{children}
			</Box>
		</Box>
	)
}
